/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The status of the rate response. 'pending' means the rates are still being fetched. 'failure' means there was an error fetching the rates. 'unavailable' means rates have been successfully fetched but no rates are available. 'complete' means rates have been successfully fetched.
 * @export
 */
export const RateResponseStatus = {
    Pending: 'pending',
    Failure: 'failure',
    Unavailable: 'unavailable',
    Complete: 'complete'
} as const;
export type RateResponseStatus = typeof RateResponseStatus[keyof typeof RateResponseStatus];


export function instanceOfRateResponseStatus(value: any): boolean {
    for (const key in RateResponseStatus) {
        if (Object.prototype.hasOwnProperty.call(RateResponseStatus, key)) {
            if (RateResponseStatus[key as keyof typeof RateResponseStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RateResponseStatusFromJSON(json: any): RateResponseStatus {
    return RateResponseStatusFromJSONTyped(json, false);
}

export function RateResponseStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): RateResponseStatus {
    return json as RateResponseStatus;
}

export function RateResponseStatusToJSON(value?: RateResponseStatus | null): any {
    return value as any;
}

export function RateResponseStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): RateResponseStatus {
    return value as RateResponseStatus;
}

